import actionCreator from "./actionCreator";

export const ADD_CAR_PARAMETERS = "ADD_CAR_PARAMETERS";
export const addCarParameters = (params) =>
  actionCreator(ADD_CAR_PARAMETERS, { params });
